<template>
  <SearchForm class="exercise-search-form" store="teaching" @change="handleChange">
    <el-select v-model="knows" filterable placeholder="知识点" :clearable="true">
      <el-option-group
        v-for="group in knowsData"
        :key="group.type"
        :label="group.title"
      >
        <el-option
          v-for="item in group.items"
          :key="item.id"
          :label="item.text"
          :value="group.type + ':' + item.id">
        </el-option>
      </el-option-group>
    </el-select>
    <template #after>
      <el-checkbox v-model="notAdd" border>隐藏已添加项</el-checkbox>
    </template>
  </SearchForm>
</template>

<script>
import SearchForm from '../SearchForm.vue'

export default {
  name: 'ExerciseSearchForm',
  components: {
    SearchForm
  },
  data () {
    return {
      knows: null,
      knowsData: null,
      loadKey: null,
      notAdd: true,
    }
  },
  watch: {
    knows () {
      this.$emit('change', 'knows')
    },
    notAdd () {
      this.$emit('change', 'notAdd')
    }
  },
  methods: {
    handleChange(filter) {
      Object.assign(this, filter)
      filter.knows = this.knows
      filter.notAdd = this.notAdd
      this.loadKnows(filter)
      this.$emit('change', filter)
    },
    loadKnows(filter) {
      if (!filter.level || !filter.num) {
        return
      }
      let key = `${filter.level}-${filter.num}`
      if (this.loadKey == key) {
        return
      }
      this.knows = null
      this.loadKey = key
      this.$http.get('api/exercise/knows', { params: filter }).then(res => {
        this.knowsData = res.data
      })
    }
  }
}
</script>

